import { render, staticRenderFns } from "./loadingConfirm.vue?vue&type=template&id=14981266&scoped=true"
import script from "./loadingConfirm.vue?vue&type=script&lang=js"
export * from "./loadingConfirm.vue?vue&type=script&lang=js"
import style0 from "./loadingConfirm.vue?vue&type=style&index=0&id=14981266&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14981266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14981266')) {
      api.createRecord('14981266', component.options)
    } else {
      api.reload('14981266', component.options)
    }
    module.hot.accept("./loadingConfirm.vue?vue&type=template&id=14981266&scoped=true", function () {
      api.rerender('14981266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/Confirm/loadingConfirm.vue"
export default component.exports